<template>

    <div class="m-auto px-8 md:px-20 pb-8">
        <div class="py-10 flex justify-between">
            <Breadcrumbs :paths="getBreadcrumbsPath"></Breadcrumbs>
        </div>
        <!--        {{ recordPerFornitore }}-->
        <ConfermaModal @confirm="onConfirm" @reject="modal_visible = false" :backdrop="true" :visible="modal_visible">
            Confermi di voler riprendere questa versione?
        </ConfermaModal>
        <div class="max-w-screen-2xl m-auto">
            <div class="flex justify-between">
                <h1 class="text-2xl font-bold">
                    Sottoprogetto: {{ sottoprogetto?.titolo }}
                </h1>
            </div>

            <div class="rotate-x-180 overflow-x-scroll">
                <NextTable class="rotate-x-180 w-full border-separate border-spacing-3 py-4 table-fixed"
                           v-model:cols="fornitoriCols"
                           :rows="recordPerFornitore">

                    <template v-for="(c, j) in recordPerFornitore" :key="j" v-slot:[`td_${j}_0`]>
                        {{ c?.fornitore?.denominazione }}
                    </template>
                    <template v-for="(c, j) in recordPerFornitore" :key="j" v-slot:[`td_${j}_1`]="context">
                        {{ $filters.toEuroCurrency(context.context.row.totale_utili) }}
                    </template>
                    <template v-for="(c, j) in recordPerFornitore" :key="j" v-slot:[`td_${j}_2`]="context">
                        {{ $filters.toEuroCurrency(0) }}
                    </template>
                    <template v-for="(c, j) in recordPerFornitore" :key="j" v-slot:[`td_${j}_3`]="context">
                        {{ $filters.toEuroCurrency(context.context.row.totale_ricavi) }}
                    </template>

                    <template v-for="(c, j) in recordPerFornitore" :key="j" v-slot:[`td_${j}_4`]="context">
                        <router-link v-if="id && context.context.row?.fornitore?.id"
                                     :to="{name:'SottoProgettoDettaglioFornitore', params:{id:id, idf:context.context.row?.fornitore?.id}}"
                                     class="text-center inset-0 absolute flex items-center justify-center">
                            <i class="icon-chevron_destra"></i>
                        </router-link>
                    </template>
                </NextTable>

            </div>
        </div>
    </div>
</template>

<script lang="ts">
import {Options, Vue} from 'vue-class-component';
import {mapActions, mapGetters, mapState} from 'vuex';
import ConfermaModal from "@/components/ConfermaModal.vue";
import NextTable from "@/components/NextTable.vue";
import sottoProgettiManager from "../api/SottoProgetti";
import TableTooltip from "@/components/TableTooltip.vue";
import MultiselectOption from "@/components/MultiselectOption.vue";
import Breadcrumbs from "@/components/Breadcrumbs.vue";

@Options({
    name: 'SottoProgettoListaFornitori',
    components: {
        Breadcrumbs,
        MultiselectOption, TableTooltip,
        NextTable,
        ConfermaModal
    },
    props: {
        id: String,
    },
    computed: {
        ...mapState('buFieldModule', {
            sottoProgettiCols: (state: any) => state.sottoProgettiCols
        }),
        ...mapGetters('sprjDataManager', [
            'AcCostoUnitarioNetto',
            'AcCostoTotale',
            'VeBudget',
            'BudgetLordoIva',
            'Utile',
            'CostoVenditaUnitario',
            'Mol',
            'TotaleCostiEuroProgetto',
            'TotaleCostiProgetto',
            'TotaleUtiliProgetto',
            'TotaleRicaviProgetto',
            'TotaleMol',
            'ActiveTab',
            'RecordSfusi',
        ]),
    },
    methods: {
        ...mapActions('sprjDataManager', [
            'setValute',
            'setFees',
            'setDatiSottoprogetto',
            'setSottoprogetto',
        ]),
    }
})
export default class SottoProgettoListaFornitori extends Vue {
    TotaleCostiProgetto!: any
    TotaleCostiEuroProgetto!: any
    TotaleRicaviProgetto!: any
    TotaleUtiliProgetto!: any
    setValute: any;
    setDatiSottoprogetto: any;
    setSottoprogetto: any;
    setFees: any;
    ActiveTab: any;
    RecordSfusi: any;

    id!: number | string
    loading = false
    modal_visible = false

    sottoprogetto: any = {}

    last_data: any = null

    fornitoriRows = []

    onConfirm() {
    }


    get recordPerFornitore() {
        if (this.ActiveTab) {
            const record_per_fornitore = this.RecordSfusi.reduce((accumulator: any, r: any) => {
                (accumulator[r.ne_fornitore?.id] = accumulator[r.ne_fornitore?.id] || []).push(r);
                return accumulator;
            }, {})

            const ret: any[] = []
            for (const rf in record_per_fornitore) {
                ret.push({
                    fornitore: record_per_fornitore[rf][0].ne_fornitore,
                    totale_costi: this.TotaleCostiProgetto([{records: record_per_fornitore[rf]}]),
                    totale_costi_euro: this.TotaleCostiEuroProgetto([{records: record_per_fornitore[rf]}]),
                    totale_ricavi: this.TotaleRicaviProgetto([{records: record_per_fornitore[rf]}]),
                    totale_utili: this.TotaleUtiliProgetto([{records: record_per_fornitore[rf]}])
                })
            }
            return ret
        }
        return []
    }

    get getBreadcrumbsPath() {
        return [
            {
                title: 'Progetto',
                name: 'DettaglioProgetto',
                params: {id: this.sottoprogetto.progetto_id || 0}
            },
            {
                title: 'Sottoprogetto',
                name: 'DettaglioSottoProgetto',
                params: {id: this.id || 0}
            },
            {
                title: 'Fornitori',
            }
        ]
    }

    created() {
        sottoProgettiManager.sottoprogetto(this.id).then((res) => {
            this.sottoprogetto = res.data
            this.last_data = JSON.parse(this.sottoprogetto?.ultimi_dati)
            this.setSottoprogetto(this.sottoprogetto)
            this.setDatiSottoprogetto(this.last_data)
        })
    }

    fornitoriCols: any[] = [
        {
            name: 'Denominazione fornitore',
            prop: 'denominazione',
            orderable: false,
            class: 'text-left whitespace-nowrap',
            td_class: 'h-11.5 px-2 relative bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: 'Totale costi',
            prop: 'totale_costi',
            orderable: false,
            class: 'text-left whitespace-nowrap',
            td_class: 'h-11.5 px-2 text-right relative bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: 'Totale ordinato',
            prop: 'totale_ordinato',
            orderable: false,
            class: 'text-left whitespace-nowrap',
            td_class: 'h-11.5 px-2 text-right relative bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: 'Totale ricavato',
            prop: 'totale_ricavi',
            orderable: false,
            class: 'text-left whitespace-nowrap',
            td_class: 'h-11.5 px-2 text-right relative bg-next-gray-md-dark',
            resizable: false
        },
        {
            name: '',
            prop: '',
            orderable: false,
            class: 'min-w-10 w-10 whitespace-nowrap',
            td_class: 'relative hover:bg-next-orange hover:text-white bg-next-gray-md-dark',
            resizable: false
        },
    ]
}


</script>


<style lang="scss">

</style>
